var map = {
	"./11849497-2A92-47A3-A714-82D52350238A_1_105_c.jpeg": "./src/images/research/critique/11849497-2A92-47A3-A714-82D52350238A_1_105_c.jpeg",
	"./196744F7-534B-4D05-AA3E-F9FD06C41A38_1_105_c.jpeg": "./src/images/research/critique/196744F7-534B-4D05-AA3E-F9FD06C41A38_1_105_c.jpeg",
	"./1A29DE55-FC7C-4A69-804E-AD6D100165A9_1_105_c.jpeg": "./src/images/research/critique/1A29DE55-FC7C-4A69-804E-AD6D100165A9_1_105_c.jpeg",
	"./634B1CE6-87B2-4F90-B12E-04EA3D9CD092_1_105_c.jpeg": "./src/images/research/critique/634B1CE6-87B2-4F90-B12E-04EA3D9CD092_1_105_c.jpeg",
	"./71ACCBE1-D196-483A-89BD-F816316919FF_1_105_c.jpeg": "./src/images/research/critique/71ACCBE1-D196-483A-89BD-F816316919FF_1_105_c.jpeg",
	"./8E5373EF-7491-49D5-BB71-CDD8DB2D20E4_1_105_c.jpeg": "./src/images/research/critique/8E5373EF-7491-49D5-BB71-CDD8DB2D20E4_1_105_c.jpeg",
	"./9981825A-6D47-4384-B53B-E0E279B57D97_1_105_c.jpeg": "./src/images/research/critique/9981825A-6D47-4384-B53B-E0E279B57D97_1_105_c.jpeg",
	"./EB23D8A7-609B-4458-87C0-6CA2982D1534_1_105_c.jpeg": "./src/images/research/critique/EB23D8A7-609B-4458-87C0-6CA2982D1534_1_105_c.jpeg",
	"./FB486CE5-9227-45DD-926D-C2F1E110F25B_1_102_o.jpeg": "./src/images/research/critique/FB486CE5-9227-45DD-926D-C2F1E110F25B_1_102_o.jpeg",
	"./unnamed-5.png": "./src/images/research/critique/unnamed-5.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/research/critique sync \\.(png|jpe?g|svg)$";